import styled from 'styled-components';

import { AppListItem } from '@/common/components/AppListItem';

import { IAppList } from './interface';

const StyledItem = styled.div`
  &:not(:last-child) {
    padding-bottom: 12px;
  }
`;

const AppList = ({ apps = [], actionComponent }: IAppList) => {
  const ActionComponent = actionComponent;

  return (
    <div>
      {apps.map((app) => {
        return (
          <StyledItem key={app.isConnected ? app.userConnectorId : app.connectorId}>
            <AppListItem {...app} actions={actionComponent && <ActionComponent {...app} />} />
          </StyledItem>
        );
      })}
    </div>
  );
};

export { AppList };
